import madhubanipainting1 from "./assets/Madhubani_painting1.jpg"
import madhubanipainting2 from "./assets/Madhubani_painting2.jpg"
import madhubanipainting3 from "./assets/Madhubani_painting3.jpg"
import madhubanipainting4 from "./assets/Madhubani_painting4.jpg"
import madhubanivivahpainting from "./assets/Madhubani_vivah_painting.jpg"
import mithilapainting from "./assets/Mithila_painting.jpg"
import printedtotbag1 from "./assets/Printed_Tot_bag1.jpg"
import printedtotbag2 from "./assets/Printed_Tot_bag2.jpg"
import printedtotbag3 from "./assets/Printed_Tot_bag3.jpg"
import scrunchie from "./assets/Scrunchie.jpg"
import smalltotbag from "./assets/Small_tot_bag.jpg"
import wollenkeychain from "./assets/Wollen_keychain.jpg"
import wollenkeychain1 from "./assets/Wollen_keychain1.jpg"
import wollenkeychain2 from "./assets/Wollen_keychain2.jpg"
import dopt1 from "./assets/Dopt1.jpeg"
import dopt2 from "./assets/Dopt2.jpeg"
import dopt3 from "./assets/Dopt3.jpeg"
import dopt4 from "./assets/Dopt4.jpeg"
import ardhanarishwar from "./assets/valentinespecial/Ardhanarishwar.jpg"
import Besanladdupacket from "./assets/valentinespecial/Besan_laddu_packet.jpg"
import BigTeddyBearcandlesforeachone from "./assets/valentinespecial/Big_Teddy_Bear_candles_for_each_one.jpg"
import fishpainting from "./assets/valentinespecial/Fish_painting.jpg"
import glasscandlepair from "./assets/valentinespecial/Glass_candle_pair.jpg"
import gopaljismalldress from "./assets/valentinespecial/Gopal_ji_small_dress.jpg"
import gopaldressbig from "./assets/valentinespecial/Gopal_ji_big_dress.jpg"
import heartcandleeachone from "./assets/valentinespecial/Heart_candle_for_each_one.jpg"
import lordvishnu from "./assets/valentinespecial/Lord_vishnu.jpg"
import mathripacket from "./assets/valentinespecial/Mathri_packet.jpg"
import namakparepacket from "./assets/valentinespecial/Namak_Pare_packet.jpg"
import peacockpaintign from "./assets/valentinespecial/Peacock_painting.jpg"
import smallteddybearcandlepair from "./assets/valentinespecial/Small_Teddy_bear_candles_pair.jpg"
import strawberrycandlejar from "./assets/valentinespecial/Strawberry_Candle_jar.jpg"
import madhubanipainting from "./assets/valentinespecial/Madhubani_painting1.jpg"
import madhubanipainting_ from "./assets/valentinespecial/Madhubani_painting2.jpg"
import pattachitra1 from "./assets/valentinespecial/Patta_chitra1.jpg"
import pattachitra2 from "./assets/valentinespecial/Patta_chitra2.jpg"
import teddycandle1 from "./assets/valentinespecial/Teddy_candle1.jpg"
import teddycandle2 from "./assets/valentinespecial/Teddy_candle2.jpg"
import tulipcandleforeachone from "./assets/valentinespecial/Tulip_candle_for_each_one.jpg"
import tulipbouquetwithjar from "./assets/valentinespecial/Tulip_bouquet_with_jar.jpg"
import tulipbouquetwithjarforeachone from "./assets/valentinespecial/Tulip_bouquet_with_jar_or_each_one.jpg"



export const Products = [
        {
            id:0,
            img:madhubanipainting1,
            name:"Madhubani Painting",
            desc:"This Madhubani painting beautifully reflects traditional Indian  art. ",
            price:"₹ 799/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {
            id:1,
            img:madhubanipainting2,
            name:"Madhubani Painting",
            desc:"This Madhubani painting beautifully reflects traditional Indian  art.",
            price:"₹ 999/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:2,
            img:madhubanipainting3,
            name:"Madhubani Painting",
            desc:"This Madhubani painting beautifully reflects traditional Indian  art.",
            price:"₹ 999/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:3,
            img:madhubanipainting4,
            name:"Madhubani Painting",
            desc:"This Madhubani painting beautifully reflects traditional Indian  art.",
            price:"₹ 1499/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {    
            id:4,
            img:madhubanivivahpainting,
            name:"Madhubani Vivah Painting",
            desc:"This Madhubani painting beautifully reflects traditional Indian  art.",
            price:"₹ 1999/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {
            id:5,
            img:mithilapainting,
            name:"Mithila Painting",
            desc:"Traditional Madhubani art depicting love, culture, and vibrant folk life",
            price:"₹ 999/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        { 
            id:6,
            img:printedtotbag1,
            name:"Printed Tot Bag ",
            desc:"Hand painted eco-friendly tote bags with playful art and expressions",
            price:"₹ 149/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {  
            id:7,
            img:printedtotbag2,
            name:"Printed Tot Bag",
            desc:"Hand painted eco-friendly tote bags with playful art and expressions",
            price:"₹ 149/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {  
            id:8,
            img:printedtotbag3,
            name:"Printed Tot Bag",
            desc:"Hand painted eco-friendly tote bags with playful art and expressions",
            price:"₹ 149/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:9,
            img:scrunchie,
            name:"Scrunchie",
            desc:"Hand painted eco-friendly tote bags with playful art and expressions",
            price:"₹ 20/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {  
            id:10,
            img:smalltotbag,
            name:"Small Tot bag",
            desc:"Hand painted eco-friendly tote bags with playful art and expressions",
            price:"₹ 80/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:11,
            img:wollenkeychain,
            name:"Wollen Keychain",
            desc:"Hand painted eco-friendly Wollen keychains with playful art and expressions",
            price:"₹ 149/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {  
            id:12,
            img:wollenkeychain1,
            name:"Wollen Keychain",
            desc:"Hand painted eco-friendly Wollen keychains with playful art and expressions",
            price:"₹ 149/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:13,
            img:wollenkeychain2,
            name:"Wollen Keychain",
            desc:"Hand painted eco-friendly Wollen keychains with playful art and expressions",
            price:"₹ 149/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:14,
            img:dopt1,
            name:"Dupatta with Madhubani Print",
            desc:"Hand painted eco-friendly Dupatta with Madhubani Print",
            price:"₹ 1999/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:15,
            img:dopt2,
            name:"Dupatta with Madhubani Print",
            desc:"Hand painted eco-friendly Dupatta with Madhubani Print",
            price:"₹ 1999/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:16,
            img:dopt3,
            name:"Dupatta with Madhubani Print",
            desc:"Hand painted eco-friendly Dupatta with Madhubani Print",
            price:"₹ 1999/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:17,
            img:dopt4,
            name:"Dupatta with Madhubani Print",
            desc:"Hand painted eco-friendly Dupatta with Madhubani Print",
            price:"₹ 1999/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:18,
            img:ardhanarishwar,
            name:"Ardhanarishwar",
            desc:"Hand painted eco-friendly Ardhanarishwar",
            price:"₹ 1299/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:19,
            img:Besanladdupacket,
            name:"Besan Laddu Packet",
            desc:"Delicious Besan Laddu Packet",
            price:"₹ 59/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:20,
            img:BigTeddyBearcandlesforeachone,
            name:"Big Teddy Bear Candles For Each One",
            desc:"Big Teddy Bear Candles For Each One",
            price:"₹ 199/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:21,
            img:fishpainting,
            name:"Fish Painting",
            desc:"Hand painted eco-friendly Fish Painting",
            price:"₹ 799/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:22,
            img:glasscandlepair,
            name:"Glass Candle Pair",
            desc:"Hand painted eco-friendly Glass Candle Pair",
            price:"₹ 299/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:23,
            img:gopaljismalldress,
            name:"Gopal Ji Small Dress",
            desc:"Hand painted eco-friendly Gopal Ji Small Dress",
            price:"₹ 99/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:24,
            img:gopaldressbig,
            name:"Gopal Ji Big Dress",
            desc:"Hand painted eco-friendly Gopal Ji Big Dress",
            price:"₹ 149/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:25,
            img:heartcandleeachone,
            name:"Heart Candle For Each One",
            desc:"Hand painted eco-friendly Heart Candle For Each One",
            price:"₹ 99/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:26,
            img:lordvishnu,
            name:"Lord Vishnu",
            desc:"Hand painted eco-friendly Lord Vishnu",
            price:"₹ 5999/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:27,
           img:mathripacket,
           name:"Mathri Packet",
             desc:"Hand painted eco-friendly Mathri Packet",
            price:"₹ 59/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:28,
           img:namakparepacket,
           name:"Namak Pare Packet",
           desc:"Hand painted eco-friendly Lord Vishnu",
            price:"₹ 49/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:29,
           img:peacockpaintign,
           name:"Peacock Painting",
           desc:"Hand painted eco-friendly Peacock Painting",
            price:"₹ 799/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:30,
           img:smallteddybearcandlepair,
           name:"Small Teddy Bear Candle Pair",
           desc:"Hand Made eco-friendly Small Teddy Bear Candle Pair",
            price:"₹ 149/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:31,
           img:strawberrycandlejar,
           name:"Strawberry Candle Jar",
           desc:"Hand Made eco-friendly Strawberry Candle Jar",
            price:"₹ 349/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:32,
           img:madhubanipainting,
           name:"Madhubani Painting",
           desc:"Hand Made eco-friendly Madhubani Painting",
            price:"₹ 999/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:33,
           img:madhubanipainting_,
           name:"Madhubani Painting",
           desc:"Hand Made eco-friendly Madhubani Painting",
            price:"₹ 2499/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:34,
           img:pattachitra1,
           name:"Patta Chitra",
           desc:"Hand Made eco-friendly Patta Chitra",
            price:"₹ 2499/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:35,
           img:pattachitra2,
           name:"Patta Chitra",
           desc:"Hand Made eco-friendly Patta Chitra",
            price:"₹ 2499/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:36,
           img:teddycandle1,
           name:"Teddy Candle",
           desc:"Hand Made eco-friendly Teddy Candle",
            price:"₹ 199/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:37,
           img:teddycandle2,
           name:"Teddy Candle",
           desc:"Hand Made eco-friendly Teddy Candle",
            price:"₹ 199/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:38,
           img:tulipcandleforeachone,
           name:"Tulip Candle For Each One",
           desc:"Hand Made eco-friendly Tulip Candle For Each One",
            price:"₹ 299/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:39,
           img:tulipbouquetwithjar,
           name:"Tulip Bouquet With Jar",
           desc:"Hand Made eco-friendly Tulip Bouquet With Jar",
            price:"₹ 499/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
        {   
            id:40,
           img:tulipbouquetwithjarforeachone,
           name:"Tulip Bouquet With Jar For Each One",
           desc:"Hand Made eco-friendly Tulip Bouquet With Jar ",
            price:"₹ 499/-",
            oldprice:"Rp 3.500.000",
            discount:"-30%"
            
        },
    ]


